import BookLocation from 'types/BookLocation';

/**
 * @method resolveElasticSearchResults
 */
const resolveElasticSearchResults = ({ book, elasticSearchResults }) => {
  const searchResults = [];

  for (let object of elasticSearchResults.objects) {
    const marker = book.markers[object.marker_index];
    const document = book.documents[object.spine_play_order];

    for (let match of object.word_matches) {
      searchResults.push({
        marker,
        snippet: match.snippit, // backend uses different spelling
        bookLocation: new BookLocation({
          document,
          cfi: match.cfi,
          event: 'Search result',
          key: `search-result:${document.index}-${match.cfi}`,
        }),
      });
    }
  }

  return searchResults;
};

export default resolveElasticSearchResults;
